const arr = [
    // acity详情页(app使用)
    {
        path: '/acity/detail',
        component: () => import(/* webpackChunkName:"something-detail"*/'@/pages/aCity/index.vue'),
        name: 'aCity',
        meta: {
            title: '主题详情',
            wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // acity详情页(带share路径，为了使用小程序的分享)
    {
        path: '/acity/share/detail',
        component: () => import(/* webpackChunkName:"something-detail"*/'@/pages/aCity/index.vue'),
        name: 'aCityShare',
        meta: {
            title: '主题详情',
            wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 亚朵企业差旅合作
    {
        path: '/businessCoopration',
        name: 'businessCoopration',
        component: () => import(/* webpackChunkName:"something-businessCoopration"*/'@/pages/coopration/index.vue'),
        meta: {
            title: '企业服务',
        },
    },
    {
        path: '/cooprationRecord',
        name: 'cooprationRecord',
        component: () => import(/* webpackChunkName:"something-cooprationRecord"*/'@/pages/coopration/record.vue'),
        meta: {
            title: '申请记录',
        },
    },
    {
        path: '/cooprationForm',
        name: 'cooprationForm',
        component: () => import(/* webpackChunkName:"something-cooprationForm"*/'@/pages/coopration/FillForm.vue'),
        meta: {
            title: '企业合作申请',
        },
    },
    {
        path: '/cooprationSuccess',
        name: 'cooprationSuccess',
        component: () => import(/* webpackChunkName:"something-cooprationSuccess"*/'@/pages/coopration/FillSuccess.vue'),
        meta: {
            title: '企业合作申请',
        },
    },
    {
        path: '/cooprationDetail',
        name: 'cooprationDetail',
        component: () => import(/* webpackChunkName:"something-cooprationDetail"*/'@/pages/coopration/detail.vue'),
        meta: {
            title: '企业合作详情',
        },
    },
    {
        path: '/download',
        name: 'download',
        component: () => import(/* webpackChunkName:"something-download"*/'@/pages/download/index.vue'),
        meta: {
            title: '亚朵App下载',
        },
    },
];
export default arr;
